import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import React, { useEffect } from 'react'

import { getPostHogInstance } from './posthog-integration.ts'

export function LazyPostHogProvider({ children }: { children: React.ReactNode }): React.ReactNode {
  useEffect(function schedulePostHogInitialization() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(getPostHogInstance)
      return
    }
    setTimeout(getPostHogInstance, 0)
  }, [])

  // Same element type before and after PostHog initialises: a swap remounts the whole app and resets every
  // useRef below it. `posthog` is the singleton `init` mutates, so the context sees the initialised client.
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}
